export const LGA_COORDS = {
  "fct abuja|amac": [9.0579, 7.4951], "fct abuja|kwali": [8.8833, 7.0167], "fct abuja|gwagwalada": [8.9426, 7.0833],
  "fct abuja|kuje": [8.8794, 7.2276], "fct abuja|abaji": [8.475, 6.944], "fct abuja|bwari": [9.2833, 7.3833],
  "gombe|gombe": [10.2897, 11.1673], "gombe|balanga": [9.9833, 11.4333], "gombe|funakaye": [10.85, 11.4333],
  "gombe|nafada": [11.0961, 11.3328], "gombe|shongom": [9.7, 11.18], "gombe|akko": [10.05, 11.2167],
  "gombe|yamaltu/deba": [10.21, 11.39], "gombe|kaltungo": [9.8167, 11.3083], "gombe|kwami": [10.4833, 11.2333],
  "gombe|billiri": [9.8667, 11.2333], "gombe|dukku": [10.823, 10.772],
  "adamawa|toungo": [8.12, 12.05], "adamawa|madagali": [10.8833, 13.6333], "adamawa|yola north": [9.2035, 12.4954],
  "adamawa|yola south": [9.18, 12.43], "adamawa|mubi north": [10.2676, 13.27], "adamawa|mubi south": [10.2, 13.3],
  "adamawa|fufore": [9.22, 12.65], "adamawa|girei": [9.36, 12.55], "adamawa|numan": [9.4667, 12.0333],
  "niger|suleja": [9.1806, 7.1794], "kogi|ankpa": [7.37, 7.63], "kaduna|lere": [10.386, 8.573], "kano|nasarawa": [11.98, 8.55],
};

const ALIASES = { "municipal area council": "amac", "abuja municipal": "amac", kwalifct: "kwali", "y/deba": "yamaltu/deba", "yamaltu deba": "yamaltu/deba", deba: "yamaltu/deba" };

export const normLga = (lga) => {
  const k = (lga || "").trim().toLowerCase().replace(/\s+/g, " ");
  return ALIASES[k] || k;
};

export const titleLga = (k) => (k === "amac" ? "AMAC" : k.replace(/(^|[\s/])\w/g, (m) => m.toUpperCase()));

export const vendorPos = (v, stateCoords) => {
  if (v.lat != null && v.lng != null) return [v.lat, v.lng];
  return LGA_COORDS[`${(v.state || "").trim().toLowerCase()}|${normLga(v.lga)}`] || stateCoords[(v.state || "").trim()] || null;
};
